module.exports = __webpack_public_path__ + "static/media/noun-hotel-3849427-142350-cropped.b197301d.svg";